<template>
    <ModalWithButton
        name="create-voucher"
        title="Crear nuevo cupón"
        button_title="Crear nuevo cupón"
        @cerrar="reset()"
    >
        <Form
            :voucher="voucher"
            @terminado="crearVoucher()" 
        />
    </ModalWithButton>  
</template>

<script>
    import ModalWithButton from '@/components/backend/components/ModalWithButton.vue';
    import Form from '../Form.vue';

    export default {
        data() {
            return {
                voucher: {
                    discount_fixed: 0,
                    discount_percent: 0,
                    sin_vincular: false,
                    code: this.randomCode()
                },
            }
        },
        computed: {
            lista() {
                return this.$store.getters.getListaId;
            }
        },
        methods: {
            crearVoucher() {
                this.loading = true;
                this.voucher.filters = {};
                this.voucher.lista_id = this.lista;

                this.$store.dispatch(this.config.getVuexAlias('back.lista.vouchers.store'), this.voucher).then(res => {
                    this.cerrar();
                    this.$emit('creado');
                    this.loading = false;
                });            
            },
            cerrar() {
                this.$modal.hide('create-voucher')
                this.reset();
            },
            randomCode() {
                return [...crypto.getRandomValues(new Uint8Array(4))].map(m=>('0'+m.toString(16)).slice(-2)).join('').toUpperCase();
            },
            reset() {
                this.voucher = {
                    discount_fixed: 0,
                    discount_percent: 0,
                    sin_vincular: false,
                    code: this.randomCode()
                };
            }
        },
        components: {
            ModalWithButton, Form
        }
    }
</script>
